import { drawingStore } from "../store";

export const setMultiSelected = (selectedIds: string[] | null) => {
  const actions = drawingStore.reduxStore?.actions;
  const store = drawingStore.reduxStore?.store;
  if (!store || !actions) return;

  store.dispatch(actions.setMultiSelect(selectedIds));
};
